import React from 'react';
import PropTypes from 'prop-types';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';
import BrowseTilePair from './BrowseTilePair';

const BrowseDepartmentPair = ({ leftUrl, rightUrl, department }) => {
  const { withCDN } = useUrlBuilder();
  return (
    <BrowseTilePair
      title={department}
      leftImage={withCDN(`not_found/${department}_newin`)}
      leftImageTitle="NEW IN"
      leftUrl={leftUrl}
      rightImage={withCDN(`not_found/${department}_sale`)}
      rightImageTitle="SALE"
      rightUrl={rightUrl}
    />
  );
};

BrowseDepartmentPair.propTypes = {
  department: PropTypes.string,
  leftUrl: PropTypes.string.isRequired,
  rightUrl: PropTypes.string.isRequired,
};

export default BrowseDepartmentPair;
